import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

import "./styles.scss";
import Img from "Components/Img";
import Button from "Components/Common/Button";
import CartItems from "../CartItems";
import ApplyCouponSection from "../Coupon";
import PriceDetailSection from "../PriceDetails";
import UpsContent from "../UpsContent";
import ProductSlider from "Components/ProductSlider";
import { SkeletonLine } from "Components/Skeletion";
import Seo from "Components/Seo/Seo";
import DomainContext from "Context/DomainContext";
import { useTranslation } from 'react-i18next';


import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const Cart = () => {
  const { storeId } = useContext(DomainContext);
  const navigate = useNavigate();
  const tooltipRef = useRef();
  const { t } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 632);
  const [cartTooltipInfo, setCartTooltipInfo] = useState(false);

  const recentProducts = useSelector((state) => state?.recentProducts);
  const cartDetails = useSelector((state) => state?.cartItems?.[0]);

  const paymentImgSrc = "/res/img/paymentCartImg.svg";

  const isSampleOrder = cartDetails?.totals_detail?.isSample == 1;
  const cartItems = cartDetails?.totals_detail?.items || [];

  const handleResize = useCallback(() => {
    setIsMobile(window.innerWidth < 632);
  }, []);

  const handleClickOutside = useCallback((event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setCartTooltipInfo(false);
    }
  }, []);

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  const BlackTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.arrow}`]: { color: "#8B4AFE" },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#8B4AFE",
      font: "normal normal 300 14px Poppins",
      padding: 16,
      borderRadius: "10px 5px 10px 10px",
      width: "400px !important",
      height: "100px !important",
      maxWidth: "400px !important",
    },
  }));

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);

  return (
    <>
      <Seo
        metaTitle={storeId === 1 ? "Winkelwagen | Promofit.nl" : "Winkelwagen Expofit.nl"}
        metaDescription="Winkelwagen"
        metaKeywords="Winkelwagen"
      />
      <div className="cartpage">
        <div className="container responsive-cart px-4 py-8 xl-py-10">
          <div className="cartpage__container xl-flex xl-gap-x-17">
            <div className="cart__details xl-flex-1 ">
              <h1 className="cart-title pb-4">{isSampleOrder ? <span className="no-translate notranslate">{t("Sample_bestellen")}</span> :<span className="no-translate notranslate">{t("Winkelwagen")}</span>}</h1>
              <CartItems />
            </div>

            <div className="sidebar__cartpage xl-flex-0">
              <div className="sticky-kort">
              {isSampleOrder && <h3 className="fw-700 fs-18 no-translate notranslate">{t("price_overview")}</h3>}
                {!cartDetails?.totals_detail?.message && (
                  <>
                  {!cartItems.length > 0  ? (
                    <SkeletonLine width="100%" height="100px" />
                  ) : (
                    <>
                      {!isSampleOrder && <ApplyCouponSection />}
                    </>
                  )}
                    <PriceDetailSection />

                    <div className="button__info pt-4">
                      {cartItems.length > 0 ? (
                        <>
                          <Button
                            className="fs-20 line-8 fw-700 r-8 px-5 cart__button"
                            fullWidth
                            onClick={() => {
                              navigate("/checkout", {
                                state: cartDetails?.shipping_details,
                              });
                              scrollToTop();
                            }}
                          >
                            Bestellen
                            <span className="flex middle">
                              <KeyboardArrowRightIcon />
                            </span>
                          </Button>

                          <div className="payment__img mx-auto py-3 relative">
                            <Img
                              type="img"
                              src={paymentImgSrc}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contained",
                              }}
                            />
                          </div>

                          {/* Future Mondu tooltip section can go here */}
                        </>
                      ) : (
                        <SkeletonLine width="100%" height="100px" />
                      )}
                    </div>
                  </>
                )}
                <UpsContent />
              </div>
            </div>
          </div>
        </div>

        {cartDetails?.totals_detail?.message && recentProducts?.length > 0 && (
          <div className="cart__product__slider">
            <ProductSlider
              title="Recent bekeken"
              data={recentProducts}
              pageName="cart"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Cart;
